import { SxProps, Theme } from '@mui/material/styles';
import styled from 'styled-components';
import { colorPalette, fontSize, getSpacing } from 'stylesheet';

export const getTooltipSlotProps = (isChildDisabled?: boolean) => ({
  tooltip: {
    sx: {
      fontSize: fontSize.p2,
      fontWeight: 'bold',
      color: colorPalette.greyMain,
      backgroundColor: colorPalette.white,
      border: isChildDisabled
        ? `solid 1px ${colorPalette.grey_600}`
        : `solid 1px ${colorPalette.secondary_500}`,
      borderRadius: getSpacing(2),
      padding: getSpacing(2),
      margin: getSpacing(1),
    } as SxProps<Theme>,
  },
  popper: {
    sx: { maxWidth: '500px' } as SxProps<Theme>,
  },
});

export const TooltipChildrenWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
